import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { Base, IBase } from "mobx-stores/_models/base";
import {
  IAddProductGoodsReceiptItem,
  IUpdateProductGoodsReceiptItem,
  ProductGoodsReceiptItem,
} from "./product-goods-receipt-item";

export const ProductGoodsReceipt = types.compose(
  Base,
  types.model({
    importDate: types.maybeNull(types.string),
    items: types.optional(types.array(ProductGoodsReceiptItem), []),
  })
);
export interface IProductGoodsReceipt
  extends Instance<typeof ProductGoodsReceipt> {}
export interface IProductGoodsReceiptProperties
  extends SnapshotIn<typeof ProductGoodsReceipt> {}

export interface IAddProductGoodsReceipt
  extends Omit<IProductGoodsReceiptProperties, keyof IBase> {
  items: IAddProductGoodsReceiptItem[];
}

export interface IUpdateProductGoodsReceipt
  extends Omit<IProductGoodsReceiptProperties, "items"> {
  items: IUpdateProductGoodsReceiptItem[];
}
